<section class="sc-hero">
  <div class="container">

    <div class="row justify-content-center">

      <div class="col-12 col-lg-12 mt-lg-6 mb-6">
        <h1 class="heading-xxl text-center">Active Sourcing einfacher <br class="d-none d-lg-inline" />als Stellenanzeigen</h1>
      </div>

      <div class="col-12 col-md-8 col-lg-7 col-xl-7">
        <p class="lead text-center">
          Mit skillconomy gewinnst du passive Bewerber:innen für alle deine Fach- und Führungspositionen - ohne irgendetwas tun zu müssen.
        </p>
      </div>      
      
      <div class="col-12 mt-6 mt-lg-7 col-lg-10 offset-lg-1">
        <img class="img-fluid" src="assets/img/hero-visual.jpg"/>
        <!-- <div class="video-container ratio ratio-16x9">
          <video poster="assets/video/produkt.jpg" loop muted playsinline autoplay oncanplay="this.play()" onloadedmetadata="this.muted = true">
            <source src="assets/video/Teaser.mp4" type="video/mp4">
            Ihr Browser unterstützt den HTML5 Video Tag nicht.
          </video>
        </div> -->
      </div>
    </div>
  </div> 

  <div class="row justify-content-center mt-6 mt-lg-7">
	  <div class="col-auto">
		<button class="btn btn-round btn-primary btn-lg"  scAnchorLink="book" anchorReferencePosition="middle" anchorTargetPosition="middle">Jetzt Demo buchen</button>
	  </div>
	</div>
<!-- 
  <svg class="blob" preserveAspectRatio="xMidYMax slice" viewBox="0 0 2155 846" xmlns="http://www.w3.org/2000/svg">
    <path d="m1191.3615 8.99009608c179.46072-16.8766341 326.14441-13.66197326 461.28581 41.76376842 100.15004 41.0744336 177.12103 99.0858515 242.95287 164.6356965 110.83204 110.380751 191.32318 229.634341 222.6478 363.854679 14.79046 63.323997 41.86408 173.723998 35.30144 265.707399l-2153.54942 2.33225c5.67652474-179.964518 79.8652714-347.311189 217.501604-501.793772 95.947064-107.69315 235.551844-180.729117 404.604463-224.294008 112.610447-29.0204612 228.891506-51.4855357 344.590051-74.2791842 83.536802-16.4541818 168.819232-28.6194669 224.665382-37.92682872z" fill="#eef4fb" fill-rule="evenodd" transform="matrix(-1 0 0 -1 2154.64852 846.000001)" /></svg> -->

</section>